import * as React from 'react';
import { withRouter } from 'react-router-dom';

import { EError } from '@enums';

import { Translate } from '@decorators';

import { IErrorProps } from './types';

interface IErrorDescription {
	title: string | React.ReactNode;
	text: string | React.ReactNode;
}

@Translate('base.components.Error')
export class ErrorComponent extends React.Component<IErrorProps> {

	getErrorDescription(error: string): IErrorDescription {
		switch (error) {
			case EError.FORBIDDEN:
				return {
					title: this.t(`forbidden.title`),
					text: this.t('forbidden.text'),
				};

			case EError.PAGE_NOT_FOUND:
				return {
					title: this.t(`pageNotFound.title`),
					text: this.t('pageNotFound.text'),
				};

			case EError.INTERNAL_SERVER_ERROR:
				return {
					title: this.t(`internalServerError.title`),
					text: this.t('internalServerError.text'),
				};

			case EError.BAD_GATEWAY:
				return {
					title: this.t(`badGateway.title`),
					text: this.t('badGateway.text'),
				};

			default:
				return {
					title: this.t('default.title'),
					text: this.t('default.text'),
				};
		}
	}

	render() {
		const { error } = this.props;
		const errorDescription = this.getErrorDescription(error);

		return (
			<div>
				<h4>
					{errorDescription.title}
				</h4>

				<p>
					{errorDescription.text}
				</p>

				<p>
					{this.t('support')}
				</p>
			</div>
		);
	}

}

export const Error = withRouter(ErrorComponent);
